var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, darken } from "@mui/material";
export default function IntroductionSection(_a) {
    var nome = _a.nome;
    return (_jsx(Box, __assign({ component: "section", sx: function (theme) { return ({
            background: "linear-gradient(45deg, ".concat(theme.palette.primary.main, " 0%, ").concat(darken(theme.palette.primary.main, 0.3), " 100%)"),
            p: 4,
            borderTopRightRadius: theme.spacing(6),
            borderBottomLeftRadius: theme.spacing(6),
            width: "100%",
        }); } }, { children: _jsx(Typography, __assign({ variant: "h1", sx: {
                fontSize: "1.375rem",
                fontWeight: 700,
                letterSpacing: 0,
                color: "white",
            } }, { children: nome })) })));
}
